<cpd-dialog-container2
  [title]="data.title"
  [message]="data.content"
  [icon]="data.icon || 'send'"
>
  <div dialog-body>
    <section class="actions">
      <cpd-flat-button
        mat-dialog-close
        type="button"
        color="primary"
        size="large"
        text="Close"
      >
      </cpd-flat-button>
    </section>
  </div>
</cpd-dialog-container2>
